import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/Transaction`;

const ApiTransaction = {
  getTransactionById: (params) => {
    const url = `${baseServiceUrl}/getTransactionById?id=` + params;
    return ServiceApi.get(url);
  },
  getTransactionByBasketId: (params) => {
    const url = `${baseServiceUrl}/getTransactionByBasketId?basketId=` + params;
    return ServiceApi.get(url);
  },
  createTransaction: (params) => {
    const url = `${baseServiceUrl}/createTransaction`;
    return ServiceApi.post(url, params);
  },
  getAllTransaction: (params) => {
    const url = `${baseServiceUrl}/getAllTransaction`;
    return ServiceApi.get(url, { params });
  },
  deleteTransaction: (params) => {
    const url = `${baseServiceUrl}/deleteTransaction?id=` + params;
    return ServiceApi.delete(url);
  },
  updateTransaction: (params) => {
    const url = `${baseServiceUrl}/updateTransaction`;
    return ServiceApi.put(url, params);
  },
  getAllTransactionReport: (params) => {
    const url = `${baseServiceUrl}/getAllTransactionReport`;
    return ServiceApi.get(url, { params });
  },
  getSellBuyReport: (params) => {
    const url = `${baseServiceUrl}/getSellBuyReport`;
    return ServiceApi.get(url, { params });
  },
  getSellBuyReportExcel: (params) => {
    const url = `${baseServiceUrl}/getSellBuyReportExcel`;
    return ServiceApi.get(url, { params: params, responseType: 'blob' });
  },
  getAllTransactionReportExcel: (params) => {
    const url = `${baseServiceUrl}/getAllTransactionReportExcel`;
    return ServiceApi.get(url, { params: params, responseType: 'blob' });
  },
};

export default ApiTransaction;


